import { FileTextIcon, MessagesSquareIcon, GlobeIcon, CompassIcon } from 'lucide-react'

export const services = [
  {
    id: 'resume',
    icon: FileTextIcon,
    title: 'Executive Resume & Dossier Engineering',
    short:
      'Strategic, ATS-optimized executive resumes and CVs for Board Members, Vice Presidents, and C-Suite candidates.',
    description:
      'Your resume is a board-level briefing document, not a career history. Each engagement translates your leadership record into a quantified, forward-looking narrative — architected to clear applicant tracking systems and to command attention from search committees, recruiters, and boards.',
    audience: 'Board members, VPs, C-Suite candidates',
    deliverables: [
      'Executive resume or academic CV',
      'Board dossier & leadership biography',
      'Targeted cover letter framework',
      'ATS keyword and format optimization',
    ],
  },
  {
    id: 'interview',
    icon: MessagesSquareIcon,
    title: 'Targeted Interview Coaching & Offer Negotiation',
    short:
      'Evidence-based interview strategy, behavioral preparation, and executive presence coaching grounded in psychology.',
    description:
      'Drawing on proven psychological frameworks, coaching sessions build the precision and composure senior interviews demand — from first screen through panel, board presentation, and the final compensation conversation.',
    audience: 'Finalists for senior and executive roles',
    deliverables: [
      'Behavioral & situational interview prep',
      'Executive presence and messaging coaching',
      'Mock panel and board-style interviews',
      'Offer evaluation & negotiation strategy',
    ],
  },
  {
    id: 'branding',
    icon: GlobeIcon,
    title: 'Executive Digital Branding & LinkedIn Optimization',
    short:
      'Complete digital footprint positioning aligned with executive search firms and board opportunities.',
    description:
      'Retained search firms and board recruiters evaluate your digital presence before they ever call. Your LinkedIn profile and online footprint are rebuilt to signal authority, reinforce your executive brand, and surface in the searches that matter.',
    audience: 'Leaders seeking search-firm and board visibility',
    deliverables: [
      'Full LinkedIn profile rewrite & optimization',
      'Headline, About, and featured content strategy',
      'Recruiter search visibility alignment',
      'Digital brand consistency audit',
    ],
  },
  {
    id: 'transition',
    icon: CompassIcon,
    title: 'Strategic Career Transition & Search Consultation',
    short:
      'High-level search roadmaps, positioning strategy, and guidance for complex executive career moves.',
    description:
      'For leaders navigating an industry pivot, a sector change, or a return to market, consultation delivers a structured search plan — clarifying where you are most valuable, how to be positioned, and which channels lead to the right opportunity.',
    audience: 'Mid-to-late career and cross-sector transitioners',
    deliverables: [
      'Career positioning & target-role assessment',
      'Executive search roadmap and timeline',
      'Network and search-firm outreach strategy',
      'Ongoing advisory through placement',
    ],
  },
]
